/* @flow */

import CancelablePromise from '../cancelable_promise'
import cancelableFetch from '../xhr_fetch'
import type Response from '../xhr_fetch/response'

export const responseToJson = (response: Response): CancelablePromise => {
  return response ? response.json() : CancelablePromise.resolve({})
}

export const responseToBlob = (response: Response): CancelablePromise => {
  return response ? response.blob() : CancelablePromise.resolve({})
}

export const responseToText = (response: Response): CancelablePromise => {
  return response ? response.text() : CancelablePromise.resolve({})
}

export const fetchAuthHeader = (json: Object): Object => {
  if (json.auth_token) {
    sessionStorage.setItem('authToken', json.auth_token)
    delete json.auth_token
  }
  return json
}

export const handleStatus = (response: Response): CancelablePromise => {
  if (response.ok) {
    return CancelablePromise.resolve(response)
  } else {
    if (response.status == 400) {
      const errors = responseToJson(response).then((data) => data.errors || data.error)
      return CancelablePromise.reject(new ApiError(response, errors))
    } else {
      return CancelablePromise.reject(new ApiError(response))
    }
  }
}

/**
 * sets headers and body if needed
 * @param {string} url
 * @param {string} type
 * @param {FormData|String} body
 * @param {object} headers
 * @return {CancelablePromise} Response
 */
export const fetchApi = (
  url: string,
  type: string = 'GET',
  body: ?(FormData | string) = null,
  headers: Object = {}
) => {
  const authToken = sessionStorage.getItem('authToken')
  // $FlowFixMe
  headers = Object.assign(
    {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    authToken
      ? {
          Authorization: `Token token=${authToken}`
        }
      : {},
    headers
  )

  if (body instanceof FormData) {
    delete headers['Content-Type']
  }
  // $FlowFixMe
  const options = Object.assign(
    {
      method: type,
      credentials: 'include',
      redirect: 'manual',
      headers: headers
    },
    type == 'GET' || !body ? {} : { body: body }
  )

  return cancelableFetch(url, options)
}

export class ApiError {
  /**
   * response: Response
   * errors: CancelablePromise
   */
  response: Response
  errors: ?CancelablePromise
  constructor(response: Response, errors: ?CancelablePromise = null) {
    this.response = response
    this.errors = errors
  }

  get status(): number {
    return this.response.status
  }
}
